import { getApiCall } from "./tokenService";

export const getIntegrationSsoIdpResponse = (integrationServiceName: string): Promise<string> => {
    return getApiCall<string>("api/integration/ssoidpresponse/?serviceName=" + (integrationServiceName || ""), null);
};